export default __webpack_public_path__ + "static/media/brightWire.3ebc3f2f.jpg";